var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9748 7.28248L14.6819 5.57538C15.463 4.79433 16.7293 4.79433 17.5104 5.57538L18.9246 6.98959C19.7056 7.77064 19.7056 9.03697 18.9246 9.81802L17.2175 11.5251M12.9748 7.28248L17.2175 11.5251M12.9748 7.28248L6.19667 14.0607M17.2175 11.5251L10.4393 18.3033M10.4393 18.3033L9.02509 19.7175H4.78245L4.78245 15.4749L6.19667 14.0607M10.4393 18.3033L6.19667 14.0607",
    stroke: "#1E95F8",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.41530133b84bc7146693bd11d5e69c13.svg";
export { ForwardRef as ReactComponent };